module.exports = __webpack_public_path__ + "static/media/nodejs.d1ff00d0.png";